import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

// Vuetify aqui serve só pros campos de formulário e o drawer mobile.
// Todo o resto do visual vem do theme.css / DESIGN.md — canto reto, sem elevação.
export default createVuetify({
  defaults: {
    global: { rounded: 0 },
    VTextField: { variant: 'outlined', density: 'comfortable', rounded: 0, color: '#2E7FE8' },
    VTextarea: { variant: 'outlined', density: 'comfortable', rounded: 0, color: '#2E7FE8' },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2E7FE8',
          secondary: '#1B52A3',
          background: '#F1F0EC',
          surface: '#FFFFFF',
        },
      },
    },
  },
})
